import React from "react";
import "./App.css";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import { PawtraitsSite, PortfolioSite } from "Pages";

// ———————————————————— //

const App: React.FC = () => {
  const hostname = window.location.hostname;

  const isPawtraits = hostname.startsWith("pawtraits.");

  return (
    <ChakraProvider value={defaultSystem}>
      {!isPawtraits ? <PawtraitsSite /> : <PortfolioSite />}
    </ChakraProvider>
  );
};

export default App;
